module.exports = __webpack_public_path__ + "assets/b5e4c3840c289962ec546d33972da45d.mp4";